import { render, staticRenderFns } from "./common-tabover.vue?vue&type=template&id=96fb1d8c&scoped=true"
import script from "./common-tabover.vue?vue&type=script&lang=js"
export * from "./common-tabover.vue?vue&type=script&lang=js"
import style0 from "./common-tabover.vue?vue&type=style&index=0&id=96fb1d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fb1d8c",
  null
  
)

export default component.exports